module.exports = __webpack_public_path__ + "img/blik.3572cd03.svg";